// Schedule.ts
import { getJson } from '../ChoiceApi';
import { AppointmentPatientEncountersLastItem, IAppointment, IAppointmentLocation, IAppointmentResource, IAppointmentStatus, IAppointmentType } from '../Models/AppointmentModel';


export async function patientEncountersLast(patientId: number): Promise<AppointmentPatientEncountersLastItem[]> {
    return (await getJson(`api/Appointment/PatientEncountersLast/${patientId}`)) as AppointmentPatientEncountersLastItem[]
}

export async function appointmentStatuses(): Promise<IAppointmentStatus[]> {
    return (await getJson(`api/Appointment/AppointmentStatuses`)) as IAppointmentStatus[];
}

export async function appointmentTypes(): Promise<IAppointmentType[]> {
    return (await getJson(`api/Appointment/AppointmentTypes`)) as IAppointmentType[];
}

export async function appointmentResources(): Promise<IAppointmentResource[]> {
    return (await getJson(`api/Appointment/AppointmentResources`)) as IAppointmentResource[];
}

export async function appointmentLocations(): Promise<IAppointmentLocation[]> {
    return (await getJson(`api/Appointment/AppointmentLocations`)) as IAppointmentLocation[];
}

export async function appointments(patientEid: number): Promise<IAppointment[]> {
    return (await getJson(`api/Appointment/Appointments/${patientEid}`)) as IAppointment[];
}
